import { useAuth } from "@/context/AuthContext";

/**
 * Hook that returns the appropriate route based on authentication status
 *
 * @returns An object with routes for authenticated and unauthenticated users
 */
export const useAuthRedirect = () => {
  const { user } = useAuth();

  const getHomeRoute = () => {
    return user ? "/dashboard" : "/";
  };

  return {
    homeRoute: getHomeRoute(),
    isAuthenticated: !!user,
  };
};
